module.exports = __webpack_public_path__ + "img/qr_member_jitsuryoku_screenshot.de069359.png";